import type { TableAction, TableState } from "./types";
import { TableGroup } from "./TableGroup";
import { useId, type Dispatch } from "react";
import { useOverlayScale } from "../editor/hooks";

type Props = {
  tableState: TableState;
  dispatch: Dispatch<TableAction>;
};

export function Table({ tableState, dispatch }: Props) {
  const tableId = useId();
  const overlayScale = useOverlayScale();

  return (
    <table
      id={tableId}
      className="table-editor-table"
      style={{ borderWidth: `${3 / overlayScale}px` }}
    >
      <colgroup>
        {tableState.cols.map((col) => (
          <col key={col.index} style={{ width: col.width }} />
        ))}
      </colgroup>
      <TableGroup
        group="thead"
        tableId={tableId}
        tableState={tableState}
        dispatch={dispatch}
      />
      <TableGroup
        group="tbody"
        tableId={tableId}
        tableState={tableState}
        dispatch={dispatch}
      />
      <TableGroup
        group="tfoot"
        tableId={tableId}
        tableState={tableState}
        dispatch={dispatch}
      />
    </table>
  );
}
